class RacedayEditPageController {

  constructor($state, AlertService, RacedaysService, LoaderService, Upload) {
    this.$state = $state;
    this.AlertService = AlertService;
    this.RacedaysService = RacedaysService;
    this.LoaderService = LoaderService;
    this.Upload = Upload;
  }

  $onInit() {
    var self = this;
    this.id = this.$state.params.id;
    self.files = {
      'header': null,
      'dynamicLink1': null,
      'dynamicLink2': null
    };
    self.filesToRemove = {
      'header': false,
      'dynamicLink1': false,
      'dynamicLink2': false
    };
    self.countFileUploaded = 0;
    self.imageEndpoint = "/api/upload";
    self.validation = {};
  }

  storeFile(picFile, type) {
    this.files[type] = picFile;
  }

  removeFile(type) {
    this.filesToRemove[type] = true;
  }


  save() {
    var self = this;

    if (!self.validForm()) {
      self.AlertService.error("The form has validation errors.");
      return;
    }

    self.LoaderService.start();
    self.RacedaysService.update(self.raceday, self.files, self.filesToRemove)
      .then(() => {
        // empty the file array
        self.files = {};
        self.AlertService.success("Raceday has been updated");
        self.$state.go('app.racedays');
      })
      .catch((error) => {
        if (error.type === 'image') {
          self.validation = {};
          if (error.field === 'header') {
            self.files.header = null;
            self.validation.headerImage = error.message;
          }
          if (error.field === 'dynamicLink1') {
            self.files.dynamicLink1 = null;
            self.validation.dynamicLink1Image = error.message;
          }
          if (error.field === 'dynamicLink2') {
            self.files.dynamicLink2 = null;
            self.validation.dynamicLink2Image = error.message;
          }
          self.AlertService.error("There was a problem saving one or more of the raceday images.");
          // empty the file array
          self.files = {};
        }
        else {
          self.AlertService.error("There was a problem saving the raceday.");
        }
      })
      .finally(() => {
        self.LoaderService.stop();
      });
  }

  deleteRaceday(racedayId) {
    if (confirm("Are you sure? This cannot be undone.")) {
      var self = this;
      self.LoaderService.start();
      self.RacedaysService.deleteRaceday(racedayId)
        .then(() => {
          self.AlertService.success("The raceday was deleted");
          self.$state.go('app.racedays');
        })
        .catch((error) => self.AlertService.error("There was a problem deleting the raceday"))
        .finally(() => self.LoaderService.stop());
    }
  }

  validForm() {
    var self = this;
    //validation

    self.validation = {};

    if (self.raceday.name === undefined || self.raceday.name === '') {
      self.validation.title = 'Title is required';
    }
    if (self.raceday.date === undefined || self.raceday.date === '') {
      self.validation.date = 'Date is required';
    }
    if (self.raceday.timeDescription === undefined || self.raceday.timeDescription === '') {
      self.validation.timeDescription = 'Gates Open Times is required';
    }
    if (self.raceday.description === undefined || self.raceday.description === '') {
      self.validation.description = 'Information is required';
    }

    if ((!!self.raceday.dynamicLink1.url.trim() && !self.raceday.dynamicLink1.name.trim()) || (!!self.raceday.dynamicLink1.name.trim() && !self.raceday.dynamicLink1.url.trim())) {
      self.validation.dynamicLink1 = 'If using a dynamic link, both name and URL are required';
    } else if (self.raceday.dynamicLink1.url.length > 0 && !self.raceday.dynamicLink1.url.startsWith("http://") && !self.raceday.dynamicLink1.url.startsWith("https://")) {
      self.validation.dynamicLink1 = 'Please ensure dynamic link URL starts with http:// or https://';
    }

    if ((!!self.raceday.dynamicLink2.url.trim() && !self.raceday.dynamicLink2.name.trim()) || (!!self.raceday.dynamicLink2.name.trim() && !self.raceday.dynamicLink2.url.trim())) {
      self.validation.dynamicLink2 = 'If using a dynamic link, both name and URL are required';
    } else if (self.raceday.dynamicLink2.url.length > 0 && !self.raceday.dynamicLink2.url.startsWith("http://") && !self.raceday.dynamicLink2.url.startsWith("https://")) {
      self.validation.dynamicLink2 = 'Please ensure dynamic link URL starts with http:// or https://';
    }

    if (self.isEmpty(self.validation)) {
      return true;
    }
    else {
      return false;
    }

  }

  isEmpty(obj) {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
  }

}
RacedayEditPageController.$inject = ['$state', 'AlertService', 'RacedaysService', 'LoaderService', 'Upload'];
export default RacedayEditPageController;
